import { useFormatter, useTranslations } from 'next-intl';
import React, { FC, Fragment } from 'react';

import ListPlaceholder from '@/components/ListPlaceholder';

import { IconCircleCrossed48 } from '@cineamo/ui/src/icons/ic-circleCrossed';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

import EventListPlaceholder from './EventListPlaceholder';

const ProgramListPlaceholder: FC<{
    selectedDate: string;
    hasNearestShowingDate: boolean;
    onJumpToNearestShowingDate: () => void;
}> = ({ selectedDate, hasNearestShowingDate, onJumpToNearestShowingDate }) => {
    const t = useTranslations();
    const domainConfiguration = useDomainConfiguration();
    const format = useFormatter();
    const selectedDateObject = new Date(selectedDate);
    // isNaN in case 'soon' is passed
    const date = isNaN(selectedDateObject.getTime())
        ? selectedDate
        : format.dateTime(selectedDateObject, {
              month: 'long',
              day: 'numeric'
          });

    return hasNearestShowingDate ? (
        <ListPlaceholder
            customImageComponent={<IconCircleCrossed48 className="opacity-20" />}
            classNameText={'leading-6'}
            text={
                <Fragment>
                    <p>
                        {date === 'all'
                            ? t('program.no-showings-for-all-placeholder')
                            : t('program.no-showings-for-date-placeholder', { date })}
                    </p>
                    <button
                        style={{ color: domainConfiguration.style.primaryColor }}
                        className="text-body-bold-14"
                        onClick={onJumpToNearestShowingDate}>
                        {t('program.no-showings-for-date-placeholder-link')}
                    </button>
                </Fragment>
            }
        />
    ) : (
        <EventListPlaceholder />
    );
};

export default ProgramListPlaceholder;
